import { readState } from "@/__main__/app-state.mjs";
import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { CmsFeatureFlagsModel } from "@/data-models/feature-flags.mjs";

export default async function fetchData() {
  const featureFlags = await getData(
    `${appURLs.UTILS_STATIC}/nexus/feature-flags`,
    CmsFeatureFlagsModel,
    ["cms", "featureFlags"],
    {
      // We always want to check for new feature flags every 8 hours
      networkBackOffTime: 8 * 60 * 60 * 1000, // 8 hours
    },
  ).catch(() => readState.cms.featureFlags);

  return { featureFlags };
}
